/// <reference path="../app.ts" />

namespace Cfnc {
    "use strict";

    interface IstudentCalendarScope extends ng.IScope {
        vm: StudentCalendar;
        eventSources: any[];
        uiConfig: any;
    }

    interface IstudentCalendar { }

    class StudentCalendar implements IstudentCalendar {
        static controllerId: string = "studentCalendar";

        static $inject: string[] = ["$location", "Restangular", "common", "$compile", "$scope", "calendarServiceClient", "uiCalendarConfig", "$uibModal"];

        editable: boolean
        locked: boolean = false;
        inCreateMode: boolean;
        categories: Array<any>;
        filterCategories: Array<any>;
        newCategory: any;
        filterCategory: any;

        eventWell: EventDetails;
        lockedWell: EventDetails;
        editEventWell: EventDetails;
        newEventWell: EventDetails;

        editStartTime: Date;
        newStartTime: Date;
        editEndTime: Date;
        newEndTime: Date;
        editStartDate: Date;
        editEndDate: Date;
        tabIndex: number = -1;
        hideSpinner: boolean;
        savedColleges: any;
        noSavedColleges: boolean;
        show: string;
        minDate: Date;
        
        private log;

        eventRender = (event, element) => {

            var eventStart = event.start === null ? event.start : event.start._i;
            var eventEnd = event.end === null ? event.end : event.end._i;
            var eventDesc = event.desc === null ? event.desc : event.desc.replace("'", "&#39;");
            var zindex: number;

            var setEventWellCall: string = "vm.setEventWell('"
                + event.id + "', '"
                + event.schoolName + "', '"
                + event.title.replace("'", "&#39;") + "', '"
                + event.category + "', '" + eventStart + "', '"
                + eventEnd + "', '"
                + event.allDayEvent + "', '"
                + eventDesc
                + "' )";

            element.attr({
                "id": event.id,
                "name": Number(event.start._d),
                "ng-mouseover": setEventWellCall,
                "ng-focus": setEventWellCall,
                "ng-mouseleave": "vm.clearEventWell()",
                "ng-blur": "vm.clearEventWell()",
                "ng-click": "vm.lockWell()",
                "href": "",
            });
            
            this.$compile(element)(this.$scope);

        };

        eventAfterAllRender = () => {
            for (var i = 0; i < angular.element(".fc-day-grid-event").length; i++) {
                var eventAnchor = angular.element(".fc-day-grid-event:eq(" + i + ")");
                var index = eventAnchor.attr("name");
                eventAnchor.parent().attr("tabindex", index);
            }
        };

        mapToFullCalendar = (event: IEvent): IEvent => {
            var date = new Date();
            return {
                id: event.id,
                title: event.name,
                schoolName: event.schoolName,
                category: event.category,
                start: event.start,
                end: event.end,
                allDayEvent: event.allDayEvent,
                desc: event.description
            };
        };

        getEvents = (start, end, timezone, callback) => {
            this.hideSpinner = false;
            if (!start || !end) {
                return;
            }

            var queryParams = {
                beginDate: moment(start).toISOString(),
                endDate: moment(end).toISOString(),
                filterCategory: this.filterCategory.name
            };


            this.Restangular.all("Calendar/getAllEvents").getList(queryParams).then((result) => {
                callback(_.map(result, this.mapToFullCalendar));
                this.hideSpinner = true;
                return result;
            }, (reason) => {
                this.log(reason);
                this.hideSpinner = true;
                });
        };

        retrieveEvents = () => {
            this.uiCalendarConfig.calendars.studentCalendar.fullCalendar("refetchEvents");
        };

        constructor(private $location: ng.ILocationService, private Restangular: Restangular.IService, private common: ICommonFactory, private $compile: ng.ICompileService,
            private $scope: IstudentCalendarScope, private calendarServiceClient: CalendarServiceClient, private uiCalendarConfig, private $uibModal: ng.ui.bootstrap.IModalService) {

            this.log = common.logger.getLogFn(StudentCalendar.controllerId);

            this.locked = false;
            this.editable = false;
            this.inCreateMode = false;
            this.hideSpinner = false;
            this.show = "createEditTab";
            this.minDate = new Date(1899, 12);
            this.$scope.eventSources = [];

            this.$scope.uiConfig = {
                calendar: {
                    editable: false,
                    header: {
                        left: "prev,next",
                        center: "title",
                        right: "month,agendaWeek,agendaDay"
                    },
                    timezone: "local",
                    eventRender: this.eventRender,
                    eventAfterAllRender: this.eventAfterAllRender
                }
            };
            this.filterCategories = [{ name: "All Categories" }];

            this.categories = [
                {
                    name: "Unfiled"
                },
                {
                    name: "Admission"
                },
                {
                    name: "Enrollment"
                },
                {
                    name: "Registration"
                },
                {
                    name: "Financial Aid"
                },
                {
                    name: "Private"
                },
                {
                    name: "Sports"
                },
                {
                    name: "Chat"
                }
            ];

            this.filterCategories = this.filterCategories.concat(this.categories);
            this.filterCategory = this.filterCategories[0];

            this.$scope.eventSources = [this.getEvents];
            this.common.authentication.authenticate(true).then(result => {
                if (result) {
                    this.activate();
                }
            });

        }

        activate() {
            //DM: I have no idea what this line is doing. 
            //this.$scope.eventSources = [this.getEvents];
            this.common.activateController([], "calendar")
                .then(result => {
                    this.log("Activated Calendar View");
                });

            this.getSavedColleges();
        }

        setEventWell = (id: string, schoolName: string, eventName: string, category: string, startDate: string, endDate: string, isAllDay: string, description: string) => {

            if (!this.editable && (this.eventWell == null || this.eventWell.id !== id)) {

                if (this.locked) {
                    this.lockedWell = _.cloneDeep(this.eventWell);
                }

                var setEndDate = endDate != "null" ? moment(endDate).toDate() : null;

                this.eventWell = {
                    id: id,
                    schoolName: schoolName,
                    applicationDefinitionId: "",
                    userId: "",
                    allDayEvent: (isAllDay === "true"),
                    name: eventName.replace("&#39;", "'"),
                    category: category,
                    start: moment(startDate).toDate(),
                    end: setEndDate,
                    description: description.replace("&#39;", "'")
                }
            }
        };

        lockWell = () => {

            if (this.editable) {
                this.editEventWell = this.lockedWell;
            } else {

                if (!this.locked) {
                    this.lockedWell = this.eventWell;
                }
                this.locked = !this.locked;
            }
        };

        clearEventWell = () => {
            if (!this.locked) {
                this.eventWell = null;
                this.editEventWell = null;
            } else
                this.eventWell = this.lockedWell
        };

        editEvent = () => {
            if (!this.editable) {
                this.editable = true;
                this.editEventWell = this.lockedWell;

                this.editStartTime = new Date();
                this.editEndTime = new Date();

                if (!this.editEventWell.allDayEvent) {
                    this.editStartTime.setTime(this.editEventWell.start.getTime());
                    this.editEndTime.setTime(this.editEventWell.end.getTime());
                }

                this.editStartDate = new Date(this.editEventWell.start.toString());
                this.editEndDate = new Date(this.editEventWell.end.toString());
            }
        };

        setUpNewEvent = () => {
            this.inCreateMode = !this.inCreateMode;
            if (!this.newStartTime)
                this.newStartTime = new Date();
            if (!this.newEndTime)
                this.newEndTime = new Date();

            this.newCategory = this.categories[0];
        };

        setNewEventTime = () => {

            if (!this.newEventWell.allDayEvent)
                this.newEventWell.allDayEvent = false;

            if (this.newEventWell.allDayEvent == true) {
                this.newStartTime.setTime(0);
                this.newEndTime.setTime(0);
            }

            this.newEventWell.start.setHours(this.newStartTime.getHours());
            this.newEventWell.start.setMinutes(this.newStartTime.getMinutes());
            this.newEventWell.end.setHours(this.newEndTime.getHours());
            this.newEventWell.end.setMinutes(this.newEndTime.getMinutes());
        };

        setEditEventTime = () => {

            if (!this.editEventWell.allDayEvent)
                this.editEventWell.allDayEvent = false;

            if (this.editEventWell.allDayEvent == true) {
                this.editStartTime.setTime(0);
                this.editEndTime.setTime(0);
            }
            this.editEventWell.start = this.editStartDate;
            this.editEventWell.start.setHours(this.editStartTime.getHours());
            this.editEventWell.start.setMinutes(this.editStartTime.getMinutes());

            this.editEventWell.end = this.editEndDate;
            this.editEventWell.end.setHours(this.editEndTime.getHours());
            this.editEventWell.end.setMinutes(this.editEndTime.getMinutes());
        };

        save = () => {

            this.setNewEventTime();
            this.newEventWell.category = this.newCategory.name;

            this.calendarServiceClient.saveStudentEvent(this.newEventWell).then((result) => {
                if (result) {
                    this.clear();
                    this.uiCalendarConfig.calendars.studentCalendar.fullCalendar("refetchEvents");
                }
            }, (reason) => {
                this.log("Event did not save!");
            });

        };

        clear = () => {
            this.newEventWell = null;
            this.eventWell = null;
            this.inCreateMode = false;
            this.editable = false;
            this.locked = false;
        };

        updateStudentEvent = () => {
            this.setEditEventTime();

            this.calendarServiceClient.updateStudentEvent(this.editEventWell).then((result) => {
                if (result) {
                    this.clear();
                    this.uiCalendarConfig.calendars.studentCalendar.fullCalendar("refetchEvents");
                }
            }, (reason) => {
                this.log("Event did not edit");
            });
        };

        deleteStudentEvent = () => {
            var modalInstance = this.$uibModal.open({
                templateUrl: '/app/collegePlanning/ConfirmModal.html',
                size: 'sm',
                controller: 'ConfirmModal',
            });
            modalInstance.result.then((val: boolean) => {
                if (val) {
                    this.calendarServiceClient.deleteStudentEvent(this.eventWell.id).then((result) => {
                        if (result) {
                            this.clear();
                            this.uiCalendarConfig.calendars.studentCalendar.fullCalendar("refetchEvents");
                        }
                    }, (reason) => {
                        this.log("Event did not delete");
                    });
                }
            });
        };

        validateNewEndDate = (value) => {
            if (this.newEventWell) {
                var isValid = moment(value).isAfter(this.newEventWell.start);

                return isValid;
            }
            return true;
        };

        validateEditEndDate = (value) => {
            if (this.editStartDate) {
                var isValid = moment(value).isAfter(this.editStartDate);

                return isValid;
            }
            return true;
        };

        getSavedColleges = () => {
            this.Restangular.one("collegePlanning/getsavedcolleges").get().then((results) => {
                this.savedColleges = results.colleges;
                this.noSavedColleges = results.colleges.length == 0 ? true : false;
            }, (reason) => {
                console.error(reason);
            });
        };

        tab = () => {

        };
    }

    angular.module("app").controller(StudentCalendar.controllerId, StudentCalendar);
}